import React from "react";
import { Box, Tab } from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

interface TabItem {
  label: string;
  value: string;
  content: React.ReactNode;
  tabValueChange?: (value: string) => void;
}

interface TabsWrapperProps {
  tabs: TabItem[];
  defaultValue?: string;
  tabValueChange?: (value: string) => void;
}

export default function TabsWrapper({
  tabs,
  defaultValue,
  tabValueChange,
}: TabsWrapperProps) {
  const [value, setValue] = React.useState(
    defaultValue || tabs[0]?.value || "1",
  );

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
    tabValueChange?.(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange}>
            {tabs.map((tab) => (
              <Tab key={tab.value} label={tab.label} value={tab.value} />
            ))}
          </TabList>
        </Box>
        {tabs.map((tab) => (
          <TabPanel key={tab.value} value={tab.value}>
            {tab.content}
          </TabPanel>
        ))}
      </TabContext>
    </Box>
  );
}
